import { createTheme } from './Theme.utils';

const blocksTheme = {
  light: createTheme('light'),
  dark: createTheme('dark'),
};

export { blocksTheme };
